import React from 'react';
import PropTypes from 'prop-types';
import Filter from '../../Filter/Filter';
import Filters from '../../Filters/Filters';

const LocationsFilters = React.memo(props => {
  const {
    locations: {
      locations: { facet_fields },
    },
    users,
  } = props;

  if (!Object.keys(facet_fields).length) {
    return null;
  }

  const { tags, createdBy, modifiedBy } = facet_fields;

  return (
    <Filters>
      <Filter type="text" name="search" title="Search" placeholder="Search locations" />
      <Filter type="preset" preset="depth" name="folderDepth" title="Include sublocations" />
      <Filter type="checkbox" name="createdBy" title="Created by" data={createdBy} users={users} />
      <Filter type="preset" name="createdDate" title="Created date" preset="daterange" />
      <Filter
        type="checkbox"
        name="modifiedBy"
        title="Modified by"
        data={modifiedBy}
        users={users}
      />
      <Filter type="preset" name="modifiedDate" title="Modified date" preset="daterange" />
      <Filter type="tag" name="tags" title="Tags" data={tags} />
    </Filters>
  );
});

LocationsFilters.propTypes = {
  users: PropTypes.array.isRequired,
  locations: PropTypes.object.isRequired,
};

export default LocationsFilters;
